import { CanActivateFn, Router, Routes, UrlTree } from "@angular/router"
import { PlatformRole } from "./helpers/toRole"
import { AuthenticationService } from "./services/authentication/authentication.service"
import { inject } from "@angular/core"
import { Option } from "./types/option"

export const authorizationGuard: CanActivateFnWithData = (route, state) => {
    const authenticationService = inject(AuthenticationService)
    const router = inject(Router)
    const { data } = route as RouteWithData
    if (data?.roles?.length) {
        return Option.match(authenticationService.authenticatedUser(), {
            none: () => false,
            some: user => {
                return data.roles?.includes(user.role)
                    ? true
                    : router.createUrlTree(['/'])
            }
        })
    }
    return true
}

export type RouteData = {
    roles?: PlatformRole[]
}

export type RouteWithData = Routes[number] & { data?: RouteData, children?: RouteWithData[] }

type CanActivateFnWithData = CanActivateFn & { (route: { data?: RouteData }, state: any): boolean | UrlTree }